import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "deleteRoom",
  tabindex: "-1",
  "aria-labelledby": "deleteRoom",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteRoom"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "text-center my-4" }
const _hoisted_8 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_9 = {
  class: "modal fade",
  id: "deleteRoomSuccess",
  tabindex: "-1",
  "aria-labelledby": "deleteRoomSuccess",
  "aria-hidden": "true"
}
const _hoisted_10 = { class: "modal-dialog" }
const _hoisted_11 = { class: "modal-content" }
const _hoisted_12 = { class: "modal-header" }
const _hoisted_13 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteRoomSuccess"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_15 = { class: "content mx-auto" }
const _hoisted_16 = { class: "text-center my-4" }
const _hoisted_17 = { class: "modal-footer d-flex justify-content-center" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import groupsService from '@/services/groups.service'
import { useStore } from 'vuex'
import { GROUPS_STORE } from '@/store/constants'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  talkRoomId: String,
  talkRoomName: String,
},
  setup(__props) {

const props = __props

const route = useRoute()
const store = useStore()
const deleteFailed = ref<boolean>(false)
const loadingDelete = ref<boolean>(false)
const modalDeleteSuccess = ref()
const modalDelete = ref()


const DeleteRoom = async () => {
  loadingDelete.value = true
  try {
    const data = {
      create_by_admin: true,
    }
    const response = await groupsService.deleteTalkRoomApi(props.talkRoomId, data)
    if (response?.status === 200) {
      deleteFailed.value = false
      store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_TALK_ROOMS, {
        id: route.params?.group_id,
        params: {
          ...route.query,
          page: route.query?.page || 1,
          page_of_number: route.query?.page_of_number || 30,
          published: route.query?.published ? '' : true,
          create_by_admin: true,
        },
      })
      modalDelete.value.hide()
      modalDeleteSuccess.value.show()
    } else {
      deleteFailed.value = true
      modalDelete.value.hide()
      modalDeleteSuccess.value.show()
    }
    // 2022/09/12 TienNV Fix double click button confirm delete
    setTimeout(() => {
      loadingDelete.value = false
    }, 2000)
  } catch (error) {
    deleteFailed.value = true
    modalDelete.value.hide()
    modalDeleteSuccess.value.show()
    loadingDelete.value = false
  }
}

onMounted(() => {
  modalDelete.value = new Modal(document.getElementById('deleteRoom'))
  modalDeleteSuccess.value = new Modal(document.getElementById('deleteRoomSuccess'))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('deleteTalkRoom')), 1),
              _hoisted_6
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(translate)('talkRoom')) + " " + _toDisplayString('「' + __props.talkRoomName + '」') + " " + _toDisplayString(_unref(translate)('deleteGroupName')), 1),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(Button, {
                title: _unref(translate)('cancel'),
                type: 'secondary',
                "data-bs-dismiss": "modal",
                className: 'fw-bold'
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('deleteButton'),
                onClick: DeleteRoom,
                loading: loadingDelete.value,
                disabled: loadingDelete.value,
                type: 'secondary',
                className: 'fw-bold'
              }, null, 8, ["title", "loading", "disabled"])
            ])
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h5", _hoisted_13, _toDisplayString(_unref(translate)('SO10deleteTalkRoomTitle')), 1),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(deleteFailed.value ? _unref(translate)('SO10deleteTalkRoomError') : _unref(translate)('OD52deleteTalkRoomSuccessDescription')), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              class: "me-2",
              size: 'small',
              className: 'fw-bold'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})